import React from 'react';
import { Card, Skeleton, Avatar, Row, Col } from 'antd';
import Meta from 'antd/lib/card/Meta';

const Loader = () => {
  return (
    <Row justify="center" align="top" className="mainContainer">
      <Col xs={22} sm={16} md={14} lg={12} xl={10} className="whiteContainer">
        <Card style={{ padding: '20px' }}>
          <Skeleton loading={true} avatar active>
            <Meta avatar={<Avatar src={true} />} />
          </Skeleton>
        </Card>
      </Col>
    </Row>
  );
};

export default Loader;
